<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    콘텐츠댓글상세
                </div>
                <div class="">
                    <content-comment-detail-component :commentKey="commentKey"
                                                      commentType="commentDetail"></content-comment-detail-component>
                </div>

            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>

import ContentCommentDetailComponent from "@/components/content/ContentCommentDetailComponent";

export default {
    name: 'CommentDetail',
    mixins: [],
    components: {ContentCommentDetailComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            commentKey: Number(this.$route.params.idx),
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
        },
        backEvent() {
            this.$router.back()
        }

    },
    watch: {},
}
</script>
